import { render } from "./EventTemplateCard.vue?vue&type=template&id=7c71048e&scoped=true"
import script from "./EventTemplateCard.vue?vue&type=script&lang=js"
export * from "./EventTemplateCard.vue?vue&type=script&lang=js"

import "./EventTemplateCard.vue?vue&type=style&index=0&id=7c71048e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c71048e"],['__file',"src/containers/event/eventSettings/EventTemplateCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7c71048e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7c71048e', __exports__)) {
    api.reload('7c71048e', __exports__)
  }
  
  module.hot.accept("./EventTemplateCard.vue?vue&type=template&id=7c71048e&scoped=true", () => {
    api.rerender('7c71048e', render)
  })

}


export default __exports__